import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

export const clearHighlights = async (_args: unknown, context: ToolContext): Promise<ToolResult> => {
	const { threeInstance, publish } = context;
	if (!threeInstance) {
		return { success: false, error: 'Three.js instance not initialized' };
	}

	threeInstance.clearHighlight();

	publish('object', 'highlights_cleared', {
		ref: null,
		old: null,
		new: null
	});

	return { success: true, data: { cleared: true } };
};
